"use client";

import { create } from "zustand";

/**
 * Ponte para abrir o chat do site de qualquer lugar já enviando uma mensagem
 * (ex.: CTA "pergunte ao assistente" da busca). O FloatingDockChat observa
 * `pendingMessage`: quando setado, abre o painel, consome e envia via bot.
 */
interface ChatLauncherState {
    /** Mensagem aguardando o chat abrir e enviar; null = nada pendente. */
    pendingMessage: string | null;
    /** Abre o chat e envia `message` como se o usuário tivesse digitado. */
    openChatWith: (message: string) => void;
    /** Lê e limpa a mensagem pendente (consumo único). */
    consumePending: () => string | null;
}

export const useChatLauncher = create<ChatLauncherState>()((set, get) => ({
    pendingMessage: null,
    openChatWith: (message) => set({ pendingMessage: message.trim() || null }),
    consumePending: () => {
        const message = get().pendingMessage;
        if (message) set({ pendingMessage: null });
        return message;
    },
}));
